/* eslint-disable-next-line */
export interface ModulesPosComponentsProps {}

export function ModulesPosComponents(props: ModulesPosComponentsProps) {
  return (
    <div>
      <h1>Welcome to ModulesPosComponents!</h1>
    </div>
  );
}

export default ModulesPosComponents;
